import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {Box, AppBar, Toolbar, Button, TextField, Typography, IconButton, Tooltip} from '@mui/material';
// hooks
import {useContext, useState} from "react";
import {DateRangePicker} from "react-date-range";
import InfoIcon from "@mui/icons-material/Info";
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//

import NotificationsPopover from './NotificationsPopover';
import SyncOffersButton from './SyncOffersButton';
import {DateRangeContext} from "../../../pages/dashboard/DateProvider";

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export default function DashboardHeader({ onOpenSidebar, isCollapse = false, verticalLayout = false }) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive('up', 'lg');

  const dateSelectorState = useContext(DateRangeContext);

  const [dateSelectorOpen, setDateSelectorOpen] = useState(false);
  const [dateSelector, setDateSelector] = useState([
    {
      startDate: dateSelectorState.dates[0],
      endDate: dateSelectorState.dates[1],
      key: 'selection'
    }
  ]);

  return (
    <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 }
        }}
      >
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}

        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />

          <div style={{"width": "100%"}}>
            <div style={{"float":"left"}}>
                <div style={{"display":"inline-flex"}}>
                  <TextField  value={`${dateSelectorState.dates[0].toISOString().substring(0, 10)}  -  ${dateSelectorState.dates[1].toISOString().substring(0, 10)}`} onClick={()=>setDateSelectorOpen(true)}/>
                  <Tooltip style={{"marginTop": ".25em"}} title={
                    <Typography>
                        Selects The Dates To Use For Reporting. So #Sent, Open Rates, and all other reporting metrics will be for the given date range.
                    </Typography>
                }>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
                </div>
                <br/>
                {dateSelectorOpen && <div style={{"display": "inline-grid", "position": "absolute"}}>
                    <DateRangePicker
                      onChange={item => {setDateSelector([item.selection])}}
                      showSelectionPreview
                      moveRangeOnFirstSelection={false}
                      months={2}
                      ranges={dateSelector}
                      direction="horizontal"
                    />
                    <Button variant={"contained"} color={"success"} onClick={()=>{setDateSelectorOpen(false);dateSelectorState.setDateRange(dateSelector[0].startDate, dateSelector[0].endDate);}}>Apply</Button>
                </div>}
            </div>

              {/* <LanguagePopover /> */}
              <div style={{"float":"right"}}>
                <SyncOffersButton />
                <Button onClick={()=>{localStorage.removeItem('accessToken');window.location="/";}}>
                  Log Out
                </Button>
                <NotificationsPopover />
              </div>
            </div>

      </Toolbar>
    </RootStyle>
  );
}
